import React, { useContext, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { GrLogin, GrLogout } from "react-icons/gr";
import UnversalSpinner from './CommonUtilites/UniversalSpinner';
import axiosAPIinstance from '../config/axiosAPIinstance';
import { UserContext } from '../context/UserContext';

const LoginForm = () => {
  const navigate = useNavigate();
  const { login } = useContext(UserContext);

  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [loginData, setLoginData] = useState({
    mobileNumber: '',
    passwordorPin: ''
  });

  const [errorModal, setErrorModal] = useState({
    show: false,
    title: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleNewAccountClick = () => {
    navigate('/createAccount');
  };

  const handleCloseModal = () => {
    setErrorModal({ show: false, title: '', message: '' });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axiosAPIinstance.post('/user/login', loginData);

      if (response.status === 200 && response.data) {
        const { token, userDTO, authenticated } = response.data;
        login(token, userDTO, authenticated, userDTO.mobileNumber);
        setLoading(false);
      } else {
        // Not expected normally, fallback
        setErrorModal({
          show: true,
          title: "Login Failed",
          message: "Unexpected response from server. Please try again."
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      let errorMsg = "An unexpected error occurred. Please try again later.";

      if (error.response) {
        if (error.response.status === 401) {
          errorMsg = "Invalid mobile number or password.";
        } else if (error.response.status === 403) {
          errorMsg = "Access denied. Please contact support.";
        } else if (error.response.status === 404) {
          errorMsg = "User does not exist.";
        } else if (error.response.data && typeof error.response.data === 'string') {
          errorMsg = error.response.data;
        }
      }

      setErrorModal({
        show: true,
        title: "Login Error",
        message: errorMsg
      });

      console.error('Error during login:', error);
    }
  };

  return (
    <div>
      <Form className='login-container-frame' onSubmit={handleLogin}>
        <Form.Group className="mb-3">
          <Form.Label>Login ID</Form.Label>
          <Form.Control
            type="text"
            name="mobileNumber"
            placeholder="Enter mobile number"
            value={loginData.mobileNumber}
            onChange={handleInputChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type={showPass ? "text" : "password"}
            name="passwordorPin"
            placeholder="Password"
            value={loginData.passwordorPin}
            onChange={handleInputChange}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicCheckbox">
          <Form.Check
            type="checkbox"
            label="Show Password"
            onClick={() => setShowPass(!showPass)}
          />
          <Form.Text className="text-muted">
            {loading && <UnversalSpinner />}
          </Form.Text>
        </Form.Group>

        <Button variant="primary" type="submit" disabled={loading}>
          <GrLogin /> Login
        </Button>

        {/* <Button
          variant="primary"
          className='custom-indent-space'
          onClick={handleNewAccountClick}
        >
          <GrLogout /> Create Account
        </Button> */}
      </Form>

      {/* Error Modal */}
      <Modal show={errorModal.show} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{errorModal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorModal.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LoginForm;
